import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-2`}
`;

const Subtitle = styled.p`
  ${tw`text-sm text-text-secondary mb-6`}
`;

const InputGroup = styled.div`
  ${tw`mb-4`}
`;

const Label = styled.label`
  ${tw`block text-sm font-medium text-text-secondary mb-2`}
`;

const Input = styled.input`
  ${tw`w-full p-3 border border-border-default rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent`}
`;

const Row = styled.div`
  ${tw`grid grid-cols-2 gap-4`}
`;

const ContinueButton = styled.button`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto bg-black text-white hover:bg-black-hover`}
`;

const IncidentLocationStep: React.FC<StepProps> = ({ formData, updateFormData, onNext }) => {
  const location = formData.incidentLocation || {};

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({
      incidentLocation: {
        ...location,
        [field]: e.target.value,
      },
    });
  };

  return (
    <Container>
      <SectionLabel>DAMAGE DETAILS</SectionLabel>
      <Title>Where did the incident occur?</Title>
      <Subtitle>
        Please let us know the address or intersection of where the incident took place. If you
        don't know where the incident occurred, proceed to the next question.
      </Subtitle>

      <InputGroup>
        <Label>Country</Label>
        <Input
          type="text"
          placeholder="United States"
          value={location.country || ''}
          onChange={handleChange('country')}
        />
      </InputGroup>

      <InputGroup>
        <Label>Street address</Label>
        <Input
          type="text"
          placeholder="123 Main Street"
          value={location.streetAddress || ''}
          onChange={handleChange('streetAddress')}
        />
      </InputGroup>

      <Row>
        <InputGroup>
          <Label>City</Label>
          <Input
            type="text"
            placeholder="City"
            value={location.city || ''}
            onChange={handleChange('city')}
          />
        </InputGroup>

        <InputGroup>
          <Label>Postal code</Label>
          <Input
            type="text"
            placeholder="12345"
            value={location.postalCode || ''}
            onChange={handleChange('postalCode')}
          />
        </InputGroup>
      </Row>

      <ContinueButton onClick={onNext}>Continue</ContinueButton>
    </Container>
  );
};

export default IncidentLocationStep;
